import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewToggleVisibilityProp } = listModuleLenses

export default (state, { moduleId }) => viewToggleVisibilityProp(moduleId, moduleDescriptions)
